import ReactOnRails from 'react-on-rails/client';
import PersonsBadges from '../../app/PersonsBadges.jsx';

ReactOnRails.register({PersonsBadges});